var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerfomanceManagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.5H2V3.5H4V19.5H6V10.5H10V19.5H12V6.5H16V19.5H18V14.5H22V21.5Z",
    fill: "#2A8981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfomanceManagement);
export default __webpack_public_path__ + "static/media/perfomanceManagement.61152a2da13b6af012612b72b27411ee.svg";
export { ForwardRef as ReactComponent };